import { render, staticRenderFns } from "./BulkCandidateImport.vue?vue&type=template&id=94557ba2&scoped=true"
import script from "./BulkCandidateImport.vue?vue&type=script&lang=js"
export * from "./BulkCandidateImport.vue?vue&type=script&lang=js"
import style0 from "./BulkCandidateImport.vue?vue&type=style&index=0&id=94557ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94557ba2",
  null
  
)

export default component.exports